

export const Subjects = {
    Maths: { subjectId: 1, subjectName: 'Maths' } as IProgramSubject,
    Physics: { subjectId: 2, subjectName: 'Physics' } as IProgramSubject,
    Chemistry: { subjectId: 3, subjectName: 'Chemistry' } as IProgramSubject,
    Reasoning: { subjectId: 4, subjectName: 'Reasoning' } as IProgramSubject,
    Biology: { subjectId: 5, subjectName: 'Biology' } as IProgramSubject,
    English: { subjectId: 6, subjectName: 'English' } as IProgramSubject,
    Science: { subjectId: 7, subjectName: 'Science' } as IProgramSubject,
    PhysicalScience: { subjectId: 8, subjectName: 'PhysicalScience' } as IProgramSubject
}

export const SubjectsData = [
    { subjectId: 1, subjectName: 'Maths' },
    { subjectId: 2, subjectName: 'Physics' },
    { subjectId: 3, subjectName: 'Chemistry' },
    { subjectId: 4, subjectName: 'Reasoning' },
    { subjectId: 5, subjectName: 'Biology' },
    { subjectId: 6, subjectName: 'English' },
    { subjectId: 7, subjectName: 'Science' },
    { subjectId: 8, subjectName: 'PhysicalScience' }
]

export interface IProgramSubject {
    subjectId: number;
    subjectName: string;
}